import React from 'react';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';
import {faPlus, faSpinner} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {AssetsInlineTable} from '../components';
import type {IAssetsSubStepProps} from '../financials.types';

const iconPlus = faPlus as IconProp;
const iconSpinner = faSpinner as IconProp;

export const AssetsSubStep: React.FC<IAssetsSubStepProps> = ({
  assetStatus,
  isLoadingAssets,
  assetRows,
  assetCatalogue,
  assetConditions,
  isSavingAssets,
  onAddAsset,
  onUpdateAssetRowField,
  onDeleteAsset,
}) => (
  <div className="financials-assets">
    <div className="sr-only" role="status" aria-live="polite">
      {assetStatus}
    </div>

    <div className="financials-assets__actions">
      <button
        type="button"
        className="btn btn-tertiary"
        onClick={onAddAsset}
        disabled={assetCatalogue.length === 0 || isSavingAssets}
      >
        <FontAwesomeIcon icon={iconPlus} aria-hidden="true" />
        <span>Add asset</span>
      </button>
    </div>

    {isLoadingAssets ? (
      <div className="financials-assets__loading" role="status">
        <FontAwesomeIcon icon={iconSpinner} spin />
        <span>Loading assets…</span>
      </div>
    ) : null}

    {!isLoadingAssets && assetRows.length === 0 ? (
      <div className="application-card">
        <div className="application-empty-state">
          <h3>Confirm your assets for 2025</h3>
          <p>
            Add your vehicles, equipment and infrastructure so we understand the
            resources available to your operation.
          </p>
        </div>
      </div>
    ) : null}

    {!isLoadingAssets && assetRows.length > 0 ? (
      <AssetsInlineTable
        assetRows={assetRows}
        assetCatalogue={assetCatalogue}
        assetConditions={assetConditions}
        isSavingAssets={isSavingAssets}
        onUpdateAssetRowField={onUpdateAssetRowField}
        onDeleteAsset={onDeleteAsset}
      />
    ) : null}
  </div>
);
